<template>
    <el-dialog
        title="会员充值"
        @on-ok="ok"
        @on-cancel="cancel"
        :visible.sync="visible"
        :mask-closable="false">
        <el-form ref="formItem" :model="formItem" :label-width="125">
            <el-tabs @on-click="onChangeTab" v-model="activeKey">
                <el-tab-pane label="充值额度" name="credit">
                    <el-form-item label="修改余额">
                        <el-radio-group v-model="formItem.mode">
                            <el-radio value="inc" label="inc">增加</el-radio>
                            <el-radio value="dec" label="dec">减少</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="余额" prop="money"
                                  :rules="{required: activeKey == 'balance' ? true : false, message: '请输入变更的金额', trigger: 'blur'}">
                        <el-input type="number" v-model="formItem.money" style="width: 200px"></el-input>
                    </el-form-item>
                </el-tab-pane>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="formItem.remark"></el-input>
                </el-form-item>
            </el-tabs>
        </el-form>
        <template #footer>
            <el-button size="large" @click="cancel">取消</el-button>
            <el-button type="primary" size="large" @click="ok">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
    export default {
        name: "recharge",
        data() {
            return {
                // modal(对话框)是否可见
                visible: false,
                // 当前记录
                record: {},
                formItem: {
                    mode: 'inc'
                },
                activeKey: 'credit'
            }
        },
        methods: {
            // 显示对话框
            handle(record) {
                // 显示窗口
                this.visible = true
                this.formItem = {
                    mode: 'inc',
                    money: '',
                }
                // 当前记录
                this.record = record
            },
            onChangeTab: function (type) {
                this.activeKey = type
                this.formItem = {
                    mode: 'inc',
                    money: '',
                    value: ''
                }
            },
            ok: function () {
                this.$refs['formItem'].validate((valid) => {
                    if (valid) {
                        this.axios.delete('/admin/channel/recharge', {
                            data: {
                                channel_id: this.record.channel_id,
                                target: this.activeKey,
                                form: this.formItem
                            }
                        }).then((res) => {
                            if (res.code == 1) {
                                // 显示成功
                                this.$message.success(res.msg)
                                // 关闭对话框事件
                                this.cancel()
                                // 通知父端组件提交完成了
                                this.$emit('reload')
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    }
                })
                return false
            },
            cancel: function () {
                this.visible = false
            }
        }
    }
</script>

<style scoped>

</style>
